<template>
  <div id="dashboardLayout"
       class="dashboard_layout clearfix">
    <dashboard-header id="dashboardHeader"
                      class="header-wrap layout-transition-up"
                      :class="{ scroll: onScroll }"
                      @onLoading="onLoading" />
    <div class="view-wrap layout-transition-fade" ref="viewWrap" @scroll="scrollInfo">
      <router-view class="content-wrap" />
    </div>
    <transition name="loading">
      <div class="loading--wrap layout-transition-fade"
           v-if="onceLoaded && loading">
        <ba-loading :applyBackground="true"
                    :showLoadingText="true"/>
      </div>
    </transition>
  </div>
</template>

<script>
import store from '@/store'
import { mapMutations } from 'vuex'
import { EventBus } from '@/libs/event-bus'
import DashboardHeader from '@/components/dashboard/Header'
import BaLoading from '@/components/ui/ba/Loading'

export default {
  name: 'DashboardLayout',
  components: {
    DashboardHeader,
    BaLoading
  },
  created () {
    store.dispatch('storeScrollbarWidth')

    EventBus.$on('onLoading', (value) => {
      this.onLoading(value)
    })
    EventBus.$on('onError', (error, code = 500) => {
      this.setErrorData({ code, error })
    })
  },
  methods: {
    ...mapMutations([
      'setErrorData'
    ]),
    scrollInfo ({ target }) {
      this.onScroll = target.scrollTop > 0
    },
    onLoading (value) {
      this.loading = value
      if (!value && !this.onceLoaded) {
        setTimeout(() => {
          this.onceLoaded = true
        }, 1000)
      }
    }
  },
  computed: {},
  data () {
    return {
      onceLoaded: false,
      loading: true,
      onScroll: false
    }
  }
}
</script>

<style lang="scss">
.dashboard_layout {
  width: 100%;
  min-width: 1280px;
  height: 100%;
  min-height: 830px;

  .header-wrap {
    transition: transform 0.3s ease,
    margin-bottom 0.3s ease;
  }

  .view-wrap {
    height: calc(100% - 80px);
    overflow-y: auto;
    transition: height 0.3s ease;

    .content-wrap {
      display: flex;
      justify-content: center;
      min-height: 100%;
      margin: 0 auto;
    }
  }

  .loading--wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #F4F4F1;
    z-index: 20;
    transition: top 0.3s ease,
    opacity 0.3s ease,
    height 0.3s ease !important;

    .loading {
      @include positionXYcenter;
    }
  }
}

.loading-enter, .loading-leave-to {
  opacity: 0;
}
</style>
